<template>
  <section>
    <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }">
      <h4 class="h2-company">
        Kompaniya malumotlarini o'zgartirish
      </h4>
      <a-form-item label="Rasm">
        <a-input type="file" @change="imgUpload" />
        <img
          :src="cPreviewImg"
          :alt="'data'"
          width="100"
          height="100"
          class="mt-3"
        />
      </a-form-item>
      <a-form-item label="Video Link">
        <a-input
          type="url"
          v-model="value.video_url"
          :value="value.video_url"
        />
      </a-form-item>
      <a-form-item label="Sarlavha">
        <a-input v-model="value.title" :value="value.title" />
      </a-form-item>
      <a-form-item label="Sarlavha [en]">
        <a-input v-model="value.title_en" :value="value.title_en" />
      </a-form-item>
      <a-form-item label="Sarlavha [ru]">
        <a-input v-model="value.title_ru" :value="value.title_ru" />
      </a-form-item>
      <a-form-item label="Sarlavha [uz]">
        <a-input v-model="value.title_uz" :value="value.title_uz" />
      </a-form-item>
    </a-form>
  </section>
</template>

<script>
export default {
  props: {
    value: Object,
    default: () => ({}),
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      oldImg: '',
    };
  },
  computed: {
    cPreviewImg() {
      return this.oldImg
        ? this.previewImg
          ? URL.createObjectURL(this.previewImg)
          : this.oldImg
        : this.oldImg;
    },
  },
  methods: {
    imgUpload(e) {
      const files = e.target.files[0];
      this.oldImg = files;
      this.previewImg = files;
      const obj = {
        files,
        obj: true,
      };
      this.value.thumbnail = obj;
      this.$notification['success']({
        message: 'Success',
        description: 'Rasm qoshildi ):',
      });
    },
  },
  updated() {
    if (!this.oldImg) {
      this.oldImg = this.value.thumbnail;
    }
  },
};
</script>

<style scoped>
input[type='file'] {
  cursor: pointer;
  width: 100%;
  height: 37px;
  overflow: hidden;
  border-radius: 5px;
  background-color: white;
}
input[type='file']:focus {
  outline: none;
}

input[type='file']:before {
  width: 100%;
  font-size: 15px;
  line-height: 27px;

  content: 'Rasm Yuklash';
  display: inline-block;
  background: white;
  text-align: center;
  font-family: Helvetica, Arial, sans-serif;
}

input[type='file']::-webkit-file-upload-button {
  visibility: hidden;
}
.h2-company {
  text-align: center;
  width: 100%;
  margin-bottom: 23px;
}

@media (max-width: 576px) {
  .h2-company {
    font-size: 22px;
    width: 100%;
    text-align: start;
  }
}

@media (max-width: 768px) {
  .h2-company {
    width: 73%;
  }
}

@media (min-width: 900px) {
  .h2-company {
    width: 58%;
  }
}
</style>
